import ComboboxController from './combobox_controller';

export default class RemoteSelectController extends ComboboxController {
  public static values = {
    autocompleteUrl: String,
    multiple: Boolean,
    autoSubmit: Boolean,
    output: String,
    outputHtml: { type: Boolean, default: false },
    valueAttribute: { type: String, default: 'data-url-value' },
    maxWidthClass: { type: String, default: 'sm:max-w-xs' },
  };
}
